/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { JSCall, WVCall } from '../../../bridges/windvane/index.js';
import { g as getResumeCallBackData, a as getRealWebUrl } from '../../../common-42e7d8d8.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';
import '../../../safe-data-66f20265.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';

function navigateTo(params) {
    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    var handler = function (e) {
        var _a;
        (_a = params === null || params === void 0 ? void 0 : params.onResume) === null || _a === void 0 ? void 0 : _a.call(params, getResumeCallBackData(e));
        document.removeEventListener('pageResume', handler, false);
    };
    JSCall('CNHybridNavigator.registerComeBackHandler', {}, function () {
        document.addEventListener('pageResume', handler, false);
    });
    WVCall('CNHybridNavigator.openURL', params, {
        formatInput: function (input) {
            return {
                // TODO: 考虑参数预处理机制，这样就不用在Web侧，每个端都相同处理一遍
                url: getRealWebUrl(input),
            };
        },
    });
}

export { navigateTo as default };
